import { removeAlert } from 'actions/alerts/AlertsActions';
import { ADD_ALERT, AlertsAction } from 'actions/alerts/AlertsActionsTypes';
import { Middleware } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'store';

export const alertsMiddleware: Middleware =
    () => (dispatch: ThunkDispatch<RootState, null, AlertsAction>) => (action: AlertsAction) => {
        if (action.type === ADD_ALERT) {
            setTimeout(() => {
                dispatch(removeAlert(action.payload.alert.uuid));
            }, 10000);
        }

        return dispatch(action);
    };
